/*********************
 * Mobillor Technologies Pvt. ltd. CONFIDENTIAL
 * __________________
 *
 *  Mobillor Technologies Pvt. Ltd.
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Mobillor Technologies Pvt. Ltd.
 * The intellectual and technical concepts contained
 * herein are proprietary to Mobillor Technologies Pvt. Ltd.
 * may be covered by Rebublic Of India and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Mobillor Technologies Pvt. Ltd.
 */

import { useEffect, useState } from "react";
import { connect } from "react-redux";
import { useNavigate } from "react-router-dom";
import Select from "react-select";

import TextError from "utils/TextError";

// Formik and Yup

// Dashboard components
import MDBox from "components/MDBox";
import MDButton from "components/MDButton";
import MDTypography from "components/MDTypography";

// Dashboard example components
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import DataTable from "examples/Tables/DataTable";

import CloseIcon from "@mui/icons-material/Close";
import DatePicker from "react-datepicker";

// @mui material components
import Card from "@mui/material/Card";
import Grid from "@mui/material/Grid";
import Icon from "@mui/material/Icon";
import Tooltip from "@mui/material/Tooltip";

import MDCard from "components/MDCard";
import "react-datepicker/dist/react-datepicker.css";

import IconButton from "@mui/material/IconButton";
import Modal from "@mui/material/Modal";

import Alert from "@mui/material/Alert";
import Collapse from "@mui/material/Collapse";

// Notification
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
// Functions from store
import {
  createDynamicColumn,
  downloadPicklistAgeing,
  getAcn,
  getAgeingParameter,
  getCreatedActivity,
  getDocumentType,
  getDynamicColumn,
  getMovementByDocumentId,
  getPicklistAgeing,
  getPicklistAgeingDownload,
  getSubModulesByRoleId,
} from "../../../store";

import { addDays, addMinutes, format, subDays } from "date-fns";

import { CSVLink } from "react-csv";

// Cookies
import { Backdrop, CircularProgress } from "@mui/material";
import DownloadDataButton from "components/standardized-components/DownloadDataButton";
import Cookies from "universal-cookie";
const cookies = new Cookies();

const PicklistAgeing = ({
  getSubModulesByRoleId,
  getSubModulesByRoleIdReducer,
  getCreatedActivity,
  getMovementByDocReducer,
  getAcnReducer,
  getDocumentType,
  getDocumentTypeReducer,
  getAgeingParameter,
  getPicklistAgeingReducer,
  getAgeingParameterReducer,
  getMovementByDocumentId,
  getAcn,
  getPicklistAgeingDownloadReducer,
  downloadPicklistAgeingReportReducer,
  getPicklistAgeingDownload,
  getDynamicColumnReducer,
  getPicklistAgeing,
  downloadPicklistAgeing,
  createDynamicColumn,
  getDynamicColumn,
}) => {
  const styleForColumnReorder = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: 380,
    color: "black",
    // border: "2px solid #000",
    boxShadow: 24,
    p: 2,
    pt: 3,
  };
  let loginDetails = cookies.get("loginDetailsForWMS");

  let jwtToken = loginDetails?.jwt;
  let roleId = loginDetails.data.roleId;

  const style = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: { xs: 350, sm: 400, md: 520 },
    maxHeight: "90vh",
    // Remove or adjust overflowY
    // overflowY: "visible",
    boxShadow: 24,
    p: 2,
    bgcolor: "background.paper",
    borderRadius: 3,
    zIndex: 1400,
  };
  useEffect(() => {
    getSubModulesByRoleId(roleId, jwtToken);
  }, [roleId]);

  useEffect(() => {
    getAcn(jwtToken);
  }, []);

  useEffect(() => {
    getDocumentType(jwtToken);
  }, []);

  useEffect(() => {
    getAgeingParameter(jwtToken);
  }, []);

  const [documentTypeSelected, setDocumentTypeSelected] = useState("");
  const [movementTypeSelected, setMovementTypeSelected] = useState("");
  const [parameterSelected, setparameterSelected] = useState("");

  useEffect(() => {
    getMovementByDocumentId(
      documentTypeSelected ? documentTypeSelected?.value : "",
      jwtToken,
    );
  }, [documentTypeSelected]);

  const [pageNo, setPageNo] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [searchObject, setSearchObject] = useState(JSON.stringify({}));
  const [paginationObj, setPaginationObj] = useState({});
  const [errorMsgFromApi, setErrorMsgFromApi] = useState("");

  const importPageNo = (pageIndex) => {
    setPageNo(pageIndex === -1 ? pageNo : pageIndex);
  };

  const importRowsPerPage = (pageSize) => {
    setRowsPerPage(pageSize);
  };

  const importSearch = (globalFilter) => {
    setSearchObject(globalFilter ? JSON.stringify(globalFilter) : "");
  };
  const [refresh, setRefresh] = useState("");
  // setTimeout(() => {
  //   setRefresh(!refresh);
  // }, 60000);

  // useEffect(() => {
  //   getPicklistAgeing(
  //     documentTypeSelected ? documentTypeSelected.value : "",
  //     movementTypeSelected ? movementTypeSelected.value : "",
  //     parameterSelected ? parameterSelected.value : "",
  //     jwtToken
  //   );
  // }, [documentTypeSelected, movementTypeSelected, parameterSelected]);
  useEffect(() => {
    getPicklistAgeing(
      pageNo,
      rowsPerPage,
      searchObject,
      documentTypeSelected ? documentTypeSelected.value : "",
      movementTypeSelected ? movementTypeSelected.value : "",
      parameterSelected ? parameterSelected.value : "",
      jwtToken,
    );
  }, [
    pageNo,
    rowsPerPage,
    searchObject,
    documentTypeSelected,
    movementTypeSelected,
    parameterSelected,
  ]);
  useEffect(() => {
    getPicklistAgeingDownload(
      pageNo,
      rowsPerPage,
      searchObject,
      documentTypeSelected ? documentTypeSelected.value : "",
      movementTypeSelected ? movementTypeSelected.value : "",
      parameterSelected ? parameterSelected.value : "",
      jwtToken,
    );
  }, [
    pageNo,
    rowsPerPage,
    searchObject,
    documentTypeSelected,
    movementTypeSelected,
    parameterSelected,
  ]);

  const [modulesData, setModulesData] = useState([]);

  useEffect(() => {
    setModulesData(
      getSubModulesByRoleIdReducer.subModulesByRoleData.data
        ? getSubModulesByRoleIdReducer.subModulesByRoleData.data
        : [],
    );
  }, [getSubModulesByRoleIdReducer]);

  let picklistAgeingModule = modulesData.find(
    (moduleId) => moduleId.moduleId == "45716e24-cd73-4680-b525-9db71fa5ae2d",
  );

  let viewAccess = picklistAgeingModule
    ? picklistAgeingModule.actionId.includes(
        "019a34cc-7f85-4259-bd17-c5a3d801b197",
      )
    : null;

  // (finishedGoods.status === 0 && `Created`) ||
  // (finishedGoods.status === 1 && `Released`) ||
  // (finishedGoods.status === 2 && `Picking`) ||
  // (finishedGoods.status === 3 && `Picked`) ||
  // (finishedGoods.status === 4 && `Putaway`) ||
  // (finishedGoods.status === 5 && `Delivered`),

  const statusOptions = [
    {
      label: "All status",
      value: "",
    },
    {
      label: "Created",
      value: 0,
    },
    {
      label: "Released",
      value: 1,
    },
    {
      label: "Picking",
      value: 2,
    },
    {
      label: "Picked",
      value: 3,
    },
    {
      label: "Putaway",
      value: 4,
    },
    {
      label: "Delivered",
      value: 5,
    },
  ];

  const navigate = useNavigate();

  const [state, setState] = useState({
    columns: [
      { Header: "Picklist Code", accessor: "picklistCode" },
      { Header: "Document code", accessor: "documentCode" },
      { Header: "Document Number", accessor: "documentNumber" },
      {
        Header: "Status",
        accessor: "status",
        searchType: "select",
        selectOptions: statusOptions,
        placeholder: "All Status",
      },
      { Header: "Source", accessor: "source" },
      { Header: "Destination", accessor: "destination" },
      {
        Header: "Picklist delivery Date",

        accessor: "cd",
        align: "left",
        searchType: "date",
        Cell: ({ value }) => {
          return value
            ? format(
                addMinutes(
                  new Date(value),
                  new Date(value).getTimezoneOffset(),
                ),
                "dd/MM/yyyy hh:mm aaa",
              )
            : "";
        },
      },
    ],
    rows: [],
  });
  const { columns, rows } = state;

  const [Download, setDownload] = useState("");
  const dateRangeOptions = [
    { label: "Last 7 Days", value: 7 },
    { label: "Last 30 Days", value: 30 },
    { label: "Last 3 Months", value: 90 },
    { label: "Custom date Range", value: "Custom date Range" },
  ];

  const [selectedDateRange, setSelectedDateRange] = useState("");

  const handleDateRangeChange = (selected) => {
    setSelectedDateRange(selected);
  };

  const [customDate, setCustomDate] = useState("");
  const sevenDays = subDays(new Date(), 7).toISOString();
  const thityDays = subDays(new Date(), 30).toISOString();
  const nintyDays = subDays(new Date(), 90).toISOString();

  const [dateRange, setDateRange] = useState([null, null]);

  const [startDateDownload, endDateDownload] = dateRange;

  // useEffect(() => {
  //   getDateRange(jwtToken);
  // }, []);

  useEffect(() => {
    if (selectedDateRange.value == 7) {
      setCustomDate(sevenDays);
    }
    if (selectedDateRange.value == 30) {
      setCustomDate(thityDays);
    }
    if (selectedDateRange.value == 90) {
      setCustomDate(nintyDays);
    }
  }, [selectedDateRange]);

  const [createCircularModal, setCreateCircularModal] = useState(false);
  const handleCreateCircularModal = () => {
    setTimeout(() => {
      setCreateCircularModal(true);
    }, 500);
    setDownload("");
    setCustomDate("");
    setSelectedDateRange("");
    setDateRange([null, null]);
    // formik.setValues(initialValues);
    // formik.setTouched({});
    // formik.setErrors({});
  };
  const handleCreateCloseCircularModal = () => {
    setTimeout(() => {
      setCreateCircularModal(false);
    }, 500);
    setDownload("");
    setCustomDate("");
    setSelectedDateRange("");
    setDateRange([null, null]);
    // formik.setValues(initialValues);
    // formik.setTouched({});
    // formik.setErrors({});
  };
  useEffect(() => {
    downloadPicklistAgeing(
      dateRange[1] !== null
        ? addDays(dateRange[1], 1)?.toISOString()
        : new Date().toISOString(),
      dateRange[0] !== null
        ? addDays(dateRange[0], 1)?.toISOString()
        : customDate,
      pageNo,
      rowsPerPage,
      searchObject,
      documentTypeSelected ? documentTypeSelected.value : "",
      movementTypeSelected ? movementTypeSelected.value : "",
      parameterSelected ? parameterSelected.value : "",
      jwtToken,
    );
  }, [
    customDate,
    dateRange,
    documentTypeSelected,
    movementTypeSelected,
    parameterSelected,
  ]);

  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let tempFinishedGoods = [];
    let data = getPicklistAgeingReducer.picklistAgeing.data
      ? getPicklistAgeingReducer.picklistAgeing.data
      : [];
    setLoading(getPicklistAgeingReducer.loading);

    setPaginationObj(getPicklistAgeingReducer.picklistAgeing?.pagination);
    data?.map((finishedGoods) => {
      const formatDate = new Date(finishedGoods.cd);

      const finishedGoodsObject = {
        picklistCode: finishedGoods.picklistCode,
        documentCode: finishedGoods.documentCode,
        documentNumber: finishedGoods.documentNumber,
        source: finishedGoods.source,

        destination: finishedGoods.destination,
        createdDate: format(
          addMinutes(formatDate, formatDate.getTimezoneOffset()),
          "dd/MM/yyyy hh:mm aaa",
        ),
        createdDate2: format(
          addMinutes(formatDate, formatDate.getTimezoneOffset()),
          "dd/MM/yyyy hh:mm aaa",
        ),
        cd: finishedGoods.cd,
        status: (
          <button
            className={
              (finishedGoods.status === 0 && `status-created`) ||
              (finishedGoods.status === 1 && `status-warning`) ||
              (finishedGoods.status === 2 && `status-info`) ||
              (finishedGoods.status === 3 && `status-info`) ||
              (finishedGoods.status === 4 && `status-info`) ||
              (finishedGoods.status === 5 && `status-success`)
            }
            style={{ width: "5.5rem" }}
          >
            {(finishedGoods.status === 0 && `Created`) ||
              (finishedGoods.status === 1 && `Released`) ||
              (finishedGoods.status === 2 && `Picking`) ||
              (finishedGoods.status === 3 && `Picked`) ||
              (finishedGoods.status === 4 && `Putaway`) ||
              (finishedGoods.status === 5 && `Delivered`)}
          </button>
        ),
        status2:
          (finishedGoods.status === 0 && `Created`) ||
          (finishedGoods.status === 1 && `Released`) ||
          (finishedGoods.status === 2 && `Picking`) ||
          (finishedGoods.status === 3 && `Picked`) ||
          (finishedGoods.status === 4 && `Putaway`) ||
          (finishedGoods.status === 5 && `Delivered`),
      };
      tempFinishedGoods.push(finishedGoodsObject);
    });
    setState({ ...state, rows: tempFinishedGoods });
  }, [getPicklistAgeingReducer]);

  useEffect(() => {
    let tempFinishedGoods = [];
    let data = downloadPicklistAgeingReportReducer.picklistAgeing.data
      ? downloadPicklistAgeingReportReducer.picklistAgeing.data
      : [];
    // setLoading(downloadPicklistAgeingReportReducer.loading);

    // setPaginationObj(downloadPicklistAgeingReportReducer.picklistAgeing?.pagination);
    data?.map((finishedGoods) => {
      const formatDate = new Date(finishedGoods.cd);

      const finishedGoodsObject = {
        picklistCode: finishedGoods.picklistCode,
        documentCode: finishedGoods.documentCode,
        documentNumber: finishedGoods.documentNumber,
        source: finishedGoods.source,
        destination: finishedGoods.destination,
        createdDate: format(
          addMinutes(formatDate, formatDate.getTimezoneOffset()),
          "dd/MM/yyyy hh:mm aaa",
        ),
        createdDate2: format(
          addMinutes(formatDate, formatDate.getTimezoneOffset()),
          "dd/MM/yyyy hh:mm aaa",
        ),
        cd: finishedGoods.cd,
        status: (
          <button
            className={
              (finishedGoods.status === 0 && `status-created`) ||
              (finishedGoods.status === 1 && `status-warning`) ||
              (finishedGoods.status === 2 && `status-info`) ||
              (finishedGoods.status === 3 && `status-info`) ||
              (finishedGoods.status === 4 && `status-info`) ||
              (finishedGoods.status === 5 && `status-success`)
            }
            style={{ width: "5.5rem" }}
          >
            {(finishedGoods.status === 0 && `Created`) ||
              (finishedGoods.status === 1 && `Released`) ||
              (finishedGoods.status === 2 && `Picking`) ||
              (finishedGoods.status === 3 && `Picked`) ||
              (finishedGoods.status === 4 && `Putaway`) ||
              (finishedGoods.status === 5 && `Delivered`)}
          </button>
        ),
        status2:
          (finishedGoods.status === 0 && `Created`) ||
          (finishedGoods.status === 1 && `Released`) ||
          (finishedGoods.status === 2 && `Picking`) ||
          (finishedGoods.status === 3 && `Picked`) ||
          (finishedGoods.status === 4 && `Putaway`) ||
          (finishedGoods.status === 5 && `Delivered`),
      };
      tempFinishedGoods.push(finishedGoodsObject);
    });
    setDownload(tempFinishedGoods);
  }, [downloadPicklistAgeingReportReducer]);

  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);

  useEffect(() => {
    // if (startDate || endDate) {
    const isoStartDate = new Date(
      (startDate ? startDate : new Date()).getTime() -
        (startDate ? startDate : new Date()).getTimezoneOffset() * 60000,
    ).toISOString();

    const isoEndDate = new Date(
      (endDate ? endDate : new Date()).getTime() -
        (endDate ? endDate : new Date()).getTimezoneOffset() * 60000,
    ).toISOString();

    // getReports(itemIdSelected, status, isoStartDate, isoEndDate);

    // }
  }, []);

  const headers = [
    {
      label: "Picklist Code",
      key: "picklistCode",
    },
    {
      label: "DocumentCode",
      key: "documentCode",
    },
    { label: "Document Number", key: "documentNumber" },
    { label: "Status", key: "status2" },
    { label: "Source", key: "source" },
    { label: "Destination", key: "destination" },
    { label: "Picklist Delivery Date", key: "createdDate2" },
  ];

  const csvLink = {
    filename: "Picklist Age-ing.csv",
    headers: headers,
    data: Download,
  };

  const handleMovementTypeChange = (selectedOption) => {
    setMovementTypeSelected(selectedOption);
    setparameterSelected("");
  };

  const [createdActivityOptions, setCreatedActivityOptions] = useState([]);

  useEffect(() => {
    let tempCreatedActivityOptions = [];
    let data = getMovementByDocReducer.documents
      ? getMovementByDocReducer.documents
      : [];
    data.map((activity) => {
      tempCreatedActivityOptions.push({
        label: activity.mvtCode,
        value: activity.mvtId,
      });
    });
    setCreatedActivityOptions(tempCreatedActivityOptions);
  }, [getMovementByDocReducer]);

  const handleParameterChange = (selectedOption) => {
    setparameterSelected(selectedOption);
  };

  const [parameterOptions, setParameterOptions] = useState([]);

  useEffect(() => {
    let tempCreatedActivityOptions = [];
    let data = getAgeingParameterReducer.ageingParameter
      ? getAgeingParameterReducer.ageingParameter
      : [];

    const excludedValues = [
      "30 Minutes",
      "1 Hour ",
      "2 Hours",
      "3 Hours",
      "4 Hours",
      "5 Hours",
      "6 Hours",
      "7 Hours",
      "8 Hours",
      "9 Hours",
      "10 Hours",
      "11 Hours",
      "12 Hours",
    ];

    data.forEach((activity) => {
      if (!excludedValues.includes(activity.ageingValue)) {
        tempCreatedActivityOptions.push({
          label: activity.ageingValue,
          value: activity.ageingValue,
        });
      }
    });

    setParameterOptions(tempCreatedActivityOptions);
  }, [getAgeingParameterReducer]);

  const handleDocumentTypeChange = (selectedOption) => {
    setDocumentTypeSelected(selectedOption);
    setMovementTypeSelected("");
    setparameterSelected("");
  };

  const [documentTypeOptions, setDocumentTypeOptions] = useState([]);

  useEffect(() => {
    let tempDocumentTypeOptions = [];
    let data = getDocumentTypeReducer.documentType.data
      ? getDocumentTypeReducer.documentType.data
      : [];
    data.map((document) => {
      tempDocumentTypeOptions.push({
        label: document.documentName,
        value: document.documentId,
      });
    });
    setDocumentTypeOptions(tempDocumentTypeOptions);
  }, [getDocumentTypeReducer]);

  const subModuleId = "45716e24-cd73-4680-b525-9db71fa5ae2d";
  let dynamicColumnDetails = cookies.get("dynamic-column-data");
  let userId = loginDetails.data.userId;
  let hiddenColumsDetails = cookies.get("hidden-column-data");

  useEffect(() => {
    getDynamicColumn(userId, subModuleId, jwtToken);
  }, [userId, subModuleId]);

  const [loadingForDynamicColumn, setLoadingForDynamicColumn] = useState(false);
  useEffect(() => {
    let data = getDynamicColumnReducer.dynamicColumn.data
      ? getDynamicColumnReducer.dynamicColumn.data
      : [];

    setDynamicColumnData(data);
    cookies.set("hidden-column-data", JSON.stringify(data?.notVisibleFields), {
      path: "/",
    });

    setTimeout(() => {
      setLoadingForDynamicColumn(true);
    }, 1000);
  }, [getDynamicColumnReducer, loading]);

  const [openCreateColumnReorderModal, setOpenCreateColumnReorderModal] =
    useState(false);

  const handleOpenCreateColumnReorderModal = () => {
    setOpenCreateColumnReorderModal(true);
  };

  const handleCloseCreateColumnReorderModal = () => {
    setOpenCreateColumnReorderModal(false);
  };

  const [dynamicColumnData, setDynamicColumnData] = useState("");
  const [isErrorColumnReorder, setIsErrorColumnReorder] = useState(false);
  const [isSuccessColumnReorder, setIsSuccessColumnReorder] = useState(false);

  useEffect(() => {
    if (isErrorColumnReorder) {
      setTimeout(() => {
        setIsErrorColumnReorder(false);
      }, 3000);
    }
  }, [isErrorColumnReorder]);

  useEffect(() => {
    if (isSuccessColumnReorder) {
      setTimeout(() => {
        setIsSuccessColumnReorder(false);
      }, 3000);
    }
  }, [isSuccessColumnReorder]);

  const [isErrorMsgForColumnReorder, setIsErrorMsgForColumnReorder] =
    useState(false);

  const handleDynamicColumn = async () => {
    let res = await createDynamicColumn(dynamicColumnDetails, jwtToken);
    if (res.status) {
      setIsSuccessColumnReorder(true);
      getDynamicColumn(userId, subModuleId, jwtToken);
      getPicklistAgeing(
        pageNo,
        rowsPerPage,
        searchObject,
        documentTypeSelected ? documentTypeSelected.value : "",
        movementTypeSelected ? movementTypeSelected.value : "",
        parameterSelected ? parameterSelected.value : "",
        jwtToken,
      );

      setTimeout(() => {
        handleCloseCreateColumnReorderModal();
        // window.location.reload();
      }, 2250);
    }
    if (!res.status) {
      setIsErrorColumnReorder(true);
      setIsErrorMsgForColumnReorder(res?.data?.data?.msg);
    }
  };

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <MDBox pt={0} pb={3}>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <Card>
              <MDBox
                display="flex"
                flexDirection={{ xs: "column", lg: "row" }}
                justifyContent="space-between"
                alignItems="center"
                p={3}
                mb={-3}
                mt={-4}
              >
                <Grid container spacing={2}>
                  <Grid item xs={12}>
                    <MDBox>
                      <MDBox
                        display="flex"
                        mt={2}
                        flexDirection={{ xs: "column", lg: "row" }}
                      >
                        <MDBox
                          width={{ xs: "150px", lg: "600px" }}
                          style={{ marginRight: "10px" }}
                        >
                          <MDTypography
                            variant="h6"
                            style={{ fontWeight: 500 }}
                          >
                            Document Type
                          </MDTypography>
                          <Select
                            isClearable
                            placeholder="Choose One..."
                            className="select-css-for-filter"
                            maxMenuHeight={380}
                            autoComplete="off"
                            value={documentTypeSelected}
                            options={documentTypeOptions}
                            onChange={handleDocumentTypeChange}
                          />
                        </MDBox>

                        <MDBox
                          width={{ xs: "150px", lg: "600px" }}
                          style={{ marginRight: "10px" }}
                        >
                          <MDTypography
                            variant="h6"
                            style={{ fontWeight: 500 }}
                          >
                            Movement Type
                          </MDTypography>
                          <Select
                            isClearable
                            placeholder="Choose One..."
                            className="select-css-for-filter"
                            maxMenuHeight={380}
                            autoComplete="off"
                            value={movementTypeSelected}
                            options={createdActivityOptions}
                            onChange={handleMovementTypeChange}
                          />
                        </MDBox>

                        <MDBox
                          display="flex"
                          alignItems="center"
                          width={{ xs: "150px", lg: "600px" }}
                          style={{ marginRight: "10px" }}
                        >
                          <MDBox flex="1">
                            <MDTypography
                              variant="h6"
                              style={{ fontWeight: 500 }}
                            >
                              Ageing Parameter
                            </MDTypography>
                            <Select
                              isClearable
                              placeholder="Choose One..."
                              className="select-css-for-filter"
                              maxMenuHeight={380}
                              autoComplete="off"
                              value={parameterSelected}
                              options={parameterOptions}
                              onChange={handleParameterChange}
                            />
                          </MDBox>
                        </MDBox>
                        <MDBox mt={3} ml={1}>
                          {/* <CSVLink {...csvLink}> */}
                          <DownloadDataButton
                            type="button"
                            style={{ borderRadius: "5px" }}
                            size="small"
                            variant="outlined"
                            color="success"
                            iconOnly
                            tooltip="Download All Data"
                            onClick={handleCreateCircularModal}
                          >
                            <Icon>download</Icon>
                          </DownloadDataButton>
                          {/* </CSVLink> */}
                        </MDBox>
                      </MDBox>
                    </MDBox>
                  </Grid>
                </Grid>
              </MDBox>
              <Modal
                open={createCircularModal}
                onClose={handleCreateCloseCircularModal}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
              >
                <MDCard sx={style} style={{ zIndex: 0 }}>
                  <MDBox ml={3} mt={-1} display="flex" alignItems="center">
                    <MDTypography variant="h5" fontWeight="medium" flexGrow={1}>
                      Download Report
                    </MDTypography>
                    <MDBox>
                      <Tooltip title="Close">
                        <IconButton
                          aria-label="close"
                          color="inherit"
                          onClick={handleCreateCloseCircularModal}
                          style={{
                            background: "whitesmoke",
                            color: "black",
                            borderRadius: 5,
                            marginLeft: "-55px",
                          }}
                        >
                          <CloseIcon />
                        </IconButton>
                      </Tooltip>
                    </MDBox>
                  </MDBox>
                  <hr style={{ marginTop: "0.5rem", marginBottom: "1rem" }} />

                  <MDBox pt={1} pb={3} px={3}>
                    {/* <MDBox
                      component="form"
                      role="form"
                      onSubmit={formik.handleSubmit}
                    > */}
                    <MDBox style={{ marginRight: "5px", marginBottom: "10px" }}>
                      <MDTypography variant="h6" style={{ fontWeight: 500 }}>
                        Date Range
                      </MDTypography>
                      <Select
                        // isClearable
                        placeholder="Choose One..."
                        className="select-css-for-filter"
                        maxMenuHeight={130}
                        options={dateRangeOptions}
                        value={selectedDateRange}
                        onChange={handleDateRangeChange}
                      />
                    </MDBox>
                    {selectedDateRange?.value === "Custom date Range" && (
                      <MDBox
                        // width={{ xs: "125px", lg: "700px" }}
                        style={{ marginRight: "5px" }}
                      >
                        <MDTypography variant="h6">
                          Custom Date Range
                        </MDTypography>

                        <DatePicker
                          className="form-control"
                          dateFormat="dd/MM/yyyy"
                          placeholderText="Select date range"
                          onChange={(date) => setDateRange(date)}
                          isClearable={true}
                          startDate={startDateDownload}
                          endDate={endDateDownload}
                          selectsRange={true}
                          popperPlacement="right-end"

                          // withPortal
                        />

                        {/* {formik.touched.startDate &&
                            formik.errors.startDate && (
                              <TextError msg={formik.errors.startDate} />
                            )} */}
                      </MDBox>
                    )}
                    {/* <MDBox>
                        <Collapse in={isError}>
                          <Alert
                            severity="error"
                            action={
                              <IconButton
                                aria-label="close"
                                color="inherit"
                                size="small"
                                onClick={() => {
                                  setIsError(false);
                                }}
                              >
                                <CloseIcon fontSize="inherit" />
                              </IconButton>
                            }
                          >
                            {errorMsg}
                          </Alert>
                        </Collapse>
                        <Collapse in={isSuccess}>
                          <Alert
                            severity="success"
                            action={
                              <IconButton
                                aria-label="close"
                                color="inherit"
                                size="small"
                                onClick={() => {
                                  setIsSuccess(false);
                                }}
                              >
                                <CloseIcon fontSize="inherit" />
                              </IconButton>
                            }
                          >
                            Circular Created successfully
                          </Alert>
                        </Collapse>
                      </MDBox> */}
                    <MDBox mt={3}>
                      {((selectedDateRange?.value === "Custom date Range" &&
                        dateRange[0] !== null) ||
                        selectedDateRange) &&
                        Download.length < 1 && (
                          <TextError msg="No data found" />
                        )}
                      {(selectedDateRange?.value === "Custom date Range" &&
                        dateRange[0] === null) ||
                      Download.length < 1 ||
                      !selectedDateRange ? (
                        <MDButton
                          color="success"
                          fullWidth
                          type="button"
                          disabled
                        >
                          Submit
                        </MDButton>
                      ) : (
                        <CSVLink
                          {...csvLink}
                          onClick={() => {
                            // Close modal after 2 seconds
                            setTimeout(() => {
                              handleCreateCloseCircularModal();
                            }, 1000); // 2000ms = 2 seconds
                          }}
                        >
                          <MDButton color="success" fullWidth type="button">
                            Submit
                          </MDButton>
                        </CSVLink>
                      )}
                    </MDBox>
                  </MDBox>
                  {/* </MDBox> */}
                </MDCard>
              </Modal>
              <Modal
                open={openCreateColumnReorderModal}
                onClose={handleCloseCreateColumnReorderModal}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
                style={{ backdropFilter: "blur(5px)" }}
              >
                <MDCard sx={styleForColumnReorder}>
                  <MDTypography>Are you sure you want to submit?</MDTypography>
                  <MDBox mt={2}>
                    <MDButton
                      style={{ width: "10rem", marginRight: "0.5rem" }}
                      color="info"
                      variant="outlined"
                      onClick={handleCloseCreateColumnReorderModal}
                    >
                      Cancel
                    </MDButton>
                    <MDButton
                      style={{ width: "10rem", marginLeft: "0.5rem" }}
                      color="success"
                      onClick={handleDynamicColumn}
                      // disabled={denyButtonName === "Please wait..."}
                    >
                      Submit
                    </MDButton>
                  </MDBox>
                  <MDBox mt={2}>
                    <Collapse in={isSuccessColumnReorder}>
                      <Alert
                        severity="success"
                        action={
                          <IconButton
                            aria-label="close"
                            color="inherit"
                            size="small"
                            onClick={() => {
                              setIsSuccessColumnReorder(false);
                            }}
                          >
                            <CloseIcon fontSize="inherit" />
                          </IconButton>
                        }
                      >
                        Data updated successfully!
                      </Alert>
                    </Collapse>
                    <Collapse in={isErrorColumnReorder}>
                      <Alert
                        severity="error"
                        action={
                          <IconButton
                            aria-label="close"
                            color="inherit"
                            size="small"
                            onClick={() => {
                              setIsErrorColumnReorder(false);
                            }}
                          >
                            <CloseIcon fontSize="inherit" />
                          </IconButton>
                        }
                      >
                        {isErrorMsgForColumnReorder}
                      </Alert>
                    </Collapse>
                  </MDBox>
                </MDCard>
              </Modal>

              <MDBox pt={3}>
                {loadingForDynamicColumn && (
                  <DataTable
                    table={{ columns, rows }}
                    isSorted={true}
                    tableSearch={true}
                    entriesPerPage={{
                      defaultValue: 5,
                      entries: [5, 10, 15, 20, 25, 30],
                    }}
                    showTotalEntries={true}
                    noEndBorder
                    serverSidePagination={true}
                    paginationObj={paginationObj}
                    pageNoValue={pageNo}
                    rowsPerPageValue={rowsPerPage}
                    pageNoProp={importPageNo}
                    rowsPerPageProp={importRowsPerPage}
                    searchProp={importSearch}
                    loading={loading}
                    hideColumns={hiddenColumsDetails}
                    visibleColumns2={dynamicColumnData?.visibleFields}
                    dynamicColumnData={dynamicColumnData}
                    handleOpenCreateColumnReorderModal={
                      handleOpenCreateColumnReorderModal
                    }
                    subModuleId={subModuleId}
                    userId={userId}
                  />
                )}
              </MDBox>
            </Card>
          </Grid>
        </Grid>
      </MDBox>
      {loading && (
        <Backdrop
          sx={{ color: "blue", zIndex: (theme) => theme.zIndex.drawer + 1 }}
          open
        >
          <CircularProgress color="inherit" />
        </Backdrop>
      )}

      <ToastContainer />
    </DashboardLayout>
  );
};

const mapStateToProps = (state) => {
  return {
    getSubModulesByRoleIdReducer: state.getSubModulesByRoleIdReducer,
    getMovementByDocReducer: state.getMovementByDocReducer,
    getAcnReducer: state.getAcnReducer,
    getDocumentTypeReducer: state.getDocumentTypeReducer,
    getPicklistAgeingReducer: state.getPicklistAgeingReducer,
    getAgeingParameterReducer: state.getAgeingParameterReducer,
    getPicklistAgeingDownloadReducer: state.getPicklistAgeingDownloadReducer,
    downloadPicklistAgeingReportReducer:
      state.downloadPicklistAgeingReportReducer,

    getDynamicColumnReducer: state.getDynamicColumnReducer,
  };
};

const mapStateToDispatch = (dispatch) => {
  return {
    getSubModulesByRoleId: (roleId, jwtToken) =>
      dispatch(getSubModulesByRoleId(roleId, jwtToken)),
    getCreatedActivity: (documentType, jwtToken) =>
      dispatch(getCreatedActivity(documentType, jwtToken)),
    getMovementByDocumentId: (documentTypeSelected, jwtToken) =>
      dispatch(getMovementByDocumentId(documentTypeSelected, jwtToken)),
    getAcn: (jwtToken) => dispatch(getAcn(jwtToken)),
    getDocumentType: (jwtToken) => dispatch(getDocumentType(jwtToken)),
    getAgeingParameter: (jwtToken) => dispatch(getAgeingParameter(jwtToken)),
    // getPicklistAgeing: (
    //   documentTypeSelected,
    //   movementTypeSelected,
    //   parameterSelected,
    //   jwtToken
    // ) =>
    //   dispatch(
    //     getPicklistAgeing(
    //       documentTypeSelected,
    //       movementTypeSelected,
    //       parameterSelected,
    //       jwtToken
    //     )
    //   ),
    getPicklistAgeing: (
      pageNo,
      rowsPerPage,
      searchObject,
      documentTypeSelected,
      movementTypeSelected,
      parameterSelected,
      jwtToken,
    ) =>
      dispatch(
        getPicklistAgeing(
          pageNo,
          rowsPerPage,
          searchObject,
          documentTypeSelected,
          movementTypeSelected,
          parameterSelected,
          jwtToken,
        ),
      ),
    // downloadPicklistAgeing
    getPicklistAgeingDownload: (
      pageNo,
      rowsPerPage,
      searchObject,
      documentTypeSelected,
      movementTypeSelected,
      parameterSelected,
      jwtToken,
    ) =>
      dispatch(
        getPicklistAgeingDownload(
          pageNo,
          rowsPerPage,
          searchObject,
          documentTypeSelected,
          movementTypeSelected,
          parameterSelected,
          jwtToken,
        ),
      ),
    downloadPicklistAgeing: (
      startDate,
      endDate,
      pageNo,
      rowsPerPage,
      searchObject,
      selectedItemType,
      selectedItemCode,
      selectedLocation,
      jwtToken,
    ) =>
      dispatch(
        downloadPicklistAgeing(
          startDate,
          endDate,
          pageNo,
          rowsPerPage,
          searchObject,
          selectedItemType,
          selectedItemCode,
          selectedLocation,
          jwtToken,
        ),
      ),
    getDynamicColumn: (userId, subModuleId, jwtToken) =>
      dispatch(getDynamicColumn(userId, subModuleId, jwtToken)),
    createDynamicColumn: (payload, jwtToken) =>
      dispatch(createDynamicColumn(payload, jwtToken)),
  };
};

export default connect(mapStateToProps, mapStateToDispatch)(PicklistAgeing);
